import { RootState } from 'store';

export const getDataLoadingSelector = (store: RootState): boolean => store.dataSettings.isLoading;
export const getSingleReceiptStatusSelector = (store: RootState): boolean => store.dataSettings.singleReceiptStatus;
